export default "__VITE_ASSET__B84hzH7Z__"